module.exports = __webpack_public_path__ + "img/apexcharts.92475dc0.png";